module.exports = __webpack_public_path__ + "img/webguide_m.e75392fd.jpg";